module.exports = __webpack_public_path__ + "static/media/male.b2f21d1f.svg";